<template>
  <div class="page page-health">
    <div class="page-title">Статус здоровья</div>

    <div v-if="!loaded" class="loader"></div>

    <div class="alert alert-danger"
         role="alert"
         v-if="error">
      <div><i class="fas fa-exclamation-triangle"></i> {{error}}</div>
    </div>

    <div v-if="loaded">
      <div
          class="health-group"
          v-for="(parent, parentKey) in data"
          :key="parentKey">

        <div class="health-title">{{parent.name}}</div>

        <div class="health-items">
          <div
              class="health-item"
              v-for="(child, childKey) in parent.items"
              :key="childKey">
            <i :class="`fas fa-circle status-${child.value}`"></i>
            {{child.name}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Health',

    data() {
      return {
        loaded: false,
        error: '',
      };
    },

    created() {
      this.loadData();
    },

    computed: {
      healthStatus() {
        const values = {};
        const statuses = this.$store.state.healthStatus.map(status => {
          const {id, health, value, createdAt} = status;

          return {id, health, value, createdAt: new Date(createdAt)};
        });

        statuses.sort((a, b) => a.createdAt - b.createdAt);

        for (const status of statuses) {
          values[status.health] = status.value;
        }

        return values;
      },

      data() {
        const elements = this.$store.state.health.map(item => {
          const {id, name, sort, parent} = item;

          return {
            id,
            name,
            sort,
            parent,
            value: typeof this.healthStatus[id] !== 'undefined' ? this.healthStatus[id] : '0',
            items: []
          };
        });

        elements.sort((a, b) => a.sort - b.sort);

        elements.forEach(element => {
          if (element.parent) {
            const parent = elements.find(e => e.id === element.parent);

            if (parent) {
              parent.items.push(element);
            }
          }
        });

        return elements.filter(element => element.parent === null);
      },
    },

    methods: {
      async loadData() {
        this.loaded = false;
        this.error = '';

        try {
          await Promise.all([
            this.$store.dispatch('LOAD_HEALTH_STATUS'),
            this.$store.dispatch('LOAD_HEALTH'),
          ]);
        } catch(e) {
          this.error = 'Произошла ошибка. Повторите попытку позже.';
        }

        this.loaded = true;
      },
    },
  };
</script>

<style lang="scss">
  @import "../assets/scss/variables.scss";

  .page-health {
    .health-group {
      .health-title {
        position: relative;
        padding: 10px 0 10px 20px;
        font-weight: bold;
        font-size: 12px;
        text-transform: uppercase;
        color: $primary;
        background-color: $light-gray-bg;
        border-top: 2px solid $primary;
      }

      .health-items {
        .health-item {
          position: relative;
          padding: 15px 0 15px 50px;
          font-weight: bold;
          font-size: 12px;
          border-top: 1px solid $light-gray;

          i {
            position: absolute;
            top: 14px;
            left: 20px;
            font-size: 18px;

            &.status-0 {
              color: $dot-gray;
            }

            &.status-1 {
              color: #FF6969;
            }

            &.status-2 {
              color: #FFC000;
            }

            &.status-3 {
              color: #FFE598;
            }

            &.status-4 {
              color: #8BC97F;
            }

            &.status-5 {
              color: #548135;
            }
          }

          &:first-of-type {
            border-top: 0;
          }
        }
      }
    }
  }
</style>
